export default __webpack_public_path__ + "static/media/spot_baja.67c5923e.mp4";